<rw-modal
  modalId="accessManagementModal"
  datapendoid="access-management-modal"
  datatestid="access-management-modal"
  [title]="dialogTitle"
  [arialabel]="dialogTitle"
  [dismissible]="true"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div>
      @if (!clientAccessReadOnly) {
        <div>
          <div class="row access-mgmt-header-row">
            <div class="user-access-header-lines col-md-12">
              <div class="user-access-header-lines-prefix">User&nbsp;</div>
              <div>
                {{ getUserFullName() }}
              </div>
            </div>
          </div>
          <div class="row access-mgmt-header-row">
            <div class="user-access-header-lines col-md-12">
              <div class="user-access-header-lines-prefix">Organization&nbsp;</div>
              <div>{{ accessMgmtConfig?.UserProfile?.OrganizationName }}</div>
            </div>
          </div>
          <div class="row access-mgmt-header-row access-mgmt-header-row--last">
            <div class="user-access-header-lines col-md-12">
              <div class="user-access-header-lines-prefix ws-nowrap">
                Drive Mappings Available&nbsp;<span
                  [ngClass]="{ 'negative-drive-count': availableDriveCount < 0 }"
                ></span>
                <app-icon
                  source="rn-help"
                  positionStyle="absolute"
                  placement="bottom"
                  tt_datatestid="clientaccess-drivemappings-tooltip"
                  tt_datapendoid="clientaccess-drivemappings-tooltip"
                  tt_arialabel="Client access drive mappings tooltip"
                  rw-tooltip="Quantity includes external mappings as well as internal mappings shown below."
                  [escape]="false"
                ></app-icon>
              </div>
              <div>{{ availableDriveCount }}&nbsp;</div>
            </div>
          </div>
        </div>
        <hr />
        <div class="access-mgmt-main-panel">
          <div class="client-access-error-panel">
            @if (availableDriveCount === 0) {
              <span>You have reached the limit of available drives.</span>
            }
            @if (availableDriveCount < 0) {
              <span
                >You have exceeded the limit of available drives for this user. Please uncheck folders until you are
                within the limit.</span
              >
            }
          </div>
          <div class="no-margins access-mgmt-desc">
            You can modify this user's access to folders within their hosted desktop.
            <br />
            Check the box to grant access, and uncheck the box to remove access.
          </div>
          @if (settingUpTree) {
            <p class="access-mgmt-loading">Loading...</p>
          } @else {
            <div class="treeBox access-mgmt-treebox">
              <div class="client-access-treeview access-mgmt-treeview">
                <p-tree
                  [(selection)]="selectedNodesArray"
                  [value]="treeNodes"
                  selectionMode="checkbox"
                  (onNodeSelect)="nodeSelect($event)"
                  (onNodeUnselect)="nodeSelect($event)"
                  class="access-mgmt-ptree"
                >
                  <!-- Using NGTemplate here to override the label due to treeNodes displaying the child count after the label OSFB-214-->
                  <ng-template let-node pTemplate="default">
                    {{ node.label }}
                  </ng-template>
                </p-tree>
              </div>
            </div>
          }
        </div>
      }
      @else {
        <div class="access-mgmt-readonly-desc">
          <div class="access-mgmt-readonly-desc access-mgmt-readonly-desc--inner">
            {{ getReadOnlyDesc() }}
          </div>
        </div>
        @if (settingUpTree) {
          <p class="access-mgmt-loading">Loading...</p>
        } @else {
          <div class="client-access-treeview client-access-treeview-readonly access-mgmt-treeview-readonly">
            <p-tree class="access-mgmt-ptree" [(selection)]="selectedNodesArray" [value]="treeNodes">
              <!-- Using NGTemplate here to override the label due to treeNodes displaying the child count after the label OSFB-214-->
              <ng-template let-node pTemplate="default">
                {{ node.label }}
              </ng-template>
            </p-tree>
          </div>
        }
      }
    </div>
  </div>
  <div modal-footer>
    <app-button
      id="btnCancel"
      [label]="clientAccessReadOnly ? 'CLOSE' : 'CANCEL'"
      buttonStyle="addUserTeritary"
      noContentPadding="true"
      (clickActionEmitter)="dismiss()"
    >
    </app-button>
    @if (!clientAccessReadOnly) {
      <app-button
        id="btnSubmit"
        label="Save"
        [disabled]="!canSubmit"
        showProcessing="true"
        [processing]="loading"
        noContentPadding="true"
        buttonStyle="primary"
        (clickActionEmitter)="saveChanges()"
      >
      </app-button>
    }
  </div>
</rw-modal>
